module.exports = __webpack_public_path__ + "static/media/heartbeat-solid.ee3b81c9.svg";